import script from "./ArticleDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticleDetail.vue?vue&type=script&setup=true&lang=js"

import "./ArticleDetail.vue?vue&type=style&index=0&id=0b9d062e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b9d062e"]])

export default __exports__